import { FC } from 'react';
import { Caption } from '../../../../typography/caption';
import { Headline } from '../../../../typography/headline';
import { Title } from '../../../../typography/title';
import { LargeTitle } from '../../../../typography/large-title';
import { ImageBaseSize } from '../../../image-base';
import css from './style.module.css';

type Props = {
  size: ImageBaseSize;
  value: string;
};

export const Entry: FC<Props> = ({ size, value }) => {
  if (size <= 28) {
    return (
      <Caption className={css.root} level={size <= 24 ? 2 : 1} weight={1} caps>
        {value}
      </Caption>
    );
  }

  if (size <= 40) {
    return (
      <Headline className={css.root} weight={2} caps>
        {value}
      </Headline>
    );
  }

  if (size <= 48) {
    return (
      <Title className={css.root} level={3} weight={1} caps>
        {value}
      </Title>
    );
  }

  if (size <= 72) {
    return (
      <Title className={css.root} level={1} weight={1} caps>
        {value}
      </Title>
    );
  }

  return (
    <LargeTitle weight={1} caps>
      {value}
    </LargeTitle>
  );
};
